import { CheckCircle2, X } from 'lucide-react';

const comparisons = [
  {
    others: 'Start with generic goals',
    momentum: 'Start with values discovery',
  },
  {
    others: 'Static templates from the internet',
    momentum: 'AI-generated plans based on your current → target role',
  },
  {
    others: 'Habit tracking alone',
    momentum: 'Habits explicitly tied to goals tied to values',
  },
  {
    others: 'Generic AI prompts ("ChatGPT for careers")',
    momentum: 'AI grounded in your role, values, goals, and skills',
  },
  {
    others: 'Standalone app you forget about',
    momentum: 'Built-in progress tracking with visual dashboards',
  },
  {
    others: 'DIY mentor search on LinkedIn',
    momentum: 'Built-in 2-way mentorship network (seek & offer)',
  },
  {
    others: 'One-time assessment, then nothing',
    momentum: 'Sequential journey with clear progression (0% → 100%)',
  },
];

const ComparisonSection = () => {
  return (
    <section className="py-20 md:py-28 bg-gradient-to-b from-[hsl(220,25%,6%)] to-background">
      <div className="container">
        {/* Section Header */}
        <h2 className="text-3xl md:text-4xl font-display font-bold text-center mb-12">
          Not Another <span className="gradient-text">Goal Tracker</span>
        </h2>

        {/* Comparison Table */}
        <div className="max-w-4xl mx-auto">
          {/* Desktop Table */}
          <div className="hidden md:block rounded-2xl border border-border/50 overflow-hidden">
            {/* Table Header */}
            <div className="grid grid-cols-2">
              <div className="p-4 bg-secondary/30 border-b border-r border-border/50">
                <span className="text-muted-foreground font-medium">Most Career Tools</span>
              </div>
              <div className="p-4 bg-gradient-to-r from-primary/10 to-accent/10 border-b border-border/50">
                <div className="flex items-center gap-2">
                  <span className="font-display font-bold gradient-text">MomentumEQ</span>
                  <CheckCircle2 className="w-5 h-5 text-success" />
                </div>
              </div>
            </div>

            {/* Table Rows */}
            {comparisons.map((row, index) => (
              <div 
                key={index} 
                className={`grid grid-cols-2 ${index !== comparisons.length - 1 ? 'border-b border-border/30' : ''}`}
              >
                {/* Left Column - Others */}
                <div className="p-4 border-r border-border/30 bg-card/50">
                  <div className="flex items-start gap-3">
                    <X className="w-5 h-5 text-muted-foreground/50 shrink-0 mt-0.5" />
                    <span className="text-muted-foreground">{row.others}</span>
                  </div>
                </div>
                {/* Right Column - MomentumEQ */}
                <div className="p-4 bg-gradient-to-r from-primary/5 to-accent/5">
                  <div className="flex items-start gap-3">
                    <CheckCircle2 className="w-5 h-5 text-success shrink-0 mt-0.5" />
                    <span className="text-foreground">{row.momentum}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Mobile Stacked Cards */}
          <div className="md:hidden space-y-4">
            {comparisons.map((row, index) => (
              <div key={index} className="rounded-xl border border-border/50 overflow-hidden">
                {/* Others */}
                <div className="p-4 bg-secondary/30 border-b border-border/30">
                  <div className="flex items-start gap-3">
                    <X className="w-5 h-5 text-muted-foreground/50 shrink-0 mt-0.5" />
                    <div>
                      <span className="text-xs text-muted-foreground uppercase tracking-wide">Most Career Tools</span>
                      <p className="text-muted-foreground mt-1">{row.others}</p>
                    </div>
                  </div>
                </div>
                {/* MomentumEQ */}
                <div className="p-4 bg-gradient-to-r from-primary/10 to-accent/10">
                  <div className="flex items-start gap-3">
                    <CheckCircle2 className="w-5 h-5 text-success shrink-0 mt-0.5" />
                    <div>
                      <span className="text-xs gradient-text font-semibold uppercase tracking-wide">MomentumEQ</span>
                      <p className="text-foreground mt-1">{row.momentum}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
